import { lazy } from "react";
import ComingSoon from "../components/common/ComingSoon";
import PageWrapper from "../components/common/PageWrapper";
import PrivateRoute from "../components/common/RoutesWrappers/PrivateRoute";
import PublicRoute from "../components/common/RoutesWrappers/PublicRoute";
import { browserRoutes } from "./browserRoutes";

const Login = lazy(() => import("../pages/Auth/Login"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));
const Profile = lazy(() => import("../pages/Profile"));
const ChangePassword = lazy(() => import("../pages/Auth/ChangePassword"));
const Analytics = lazy(() => import("../pages/Analytics"));


const Users = lazy(() => import("../pages/Users"));

const StaticPage = lazy(() => import("../pages/StaticPage"));
const EditStaticPage = lazy(() => import("../pages/StaticPage/EditStaticPage"));

const ViewUser = lazy(() => import("../pages/Users/ViewUser"));

const FAQs = lazy(() => import("../pages/FAQS"));
const ContactUs = lazy(() => import("../pages/ContactUs"));

// Subscription Management Components
const SubscriptionManagement = lazy(() => import("../pages/SubscriptionManagement"));
const AddEditPlan = lazy(() => import("../pages/SubscriptionManagement/AddEditPlan"));

// Category Management Components
const Category = lazy(() => import("../pages/Category"));
const EditCategory = lazy(() => import("../pages/Category/EditCategory"));

// Recipe Management Components
const Recipe = lazy(() => import("../pages/Recipe"));
const AddEditRecipe = lazy(() => import("../pages/Recipe/AddEditRecipe"));
const ViewRecipe = lazy(() => import("../pages/Recipe/ViewRecipe"));

// Notification Management Components
const NotificationManagement = lazy(() => import("../pages/NotificationManagement"));

// Public Pages (no auth required)
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("../pages/TermsOfService"));

export const routerConfig = {
  // index routes
  indexRoutes: [
    {
      path: browserRoutes?.login,
      component: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: browserRoutes?.forgotPassword,
      component: (
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      ),
    },
    {
      path: browserRoutes?.resetPassword + "/:verificationToken",
      component: (
        <PublicRoute>
          <ResetPassword />
        </PublicRoute>
      ),
    },
    {
      path: browserRoutes?.privacyPolicy,
      component: (
        <PrivacyPolicy />
      ),
    },
    {
      path: browserRoutes?.termsOfService,
      component: (
        <TermsOfService />
      ),
    },
  ],
  // analytics routes
  dashboardRoutes: [
    {
      path: browserRoutes?.profile,
      component: (
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.changePassword,
      component: (
        <PrivateRoute>
          <ChangePassword />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.analytics,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <Analytics />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    // users
    {
      path: browserRoutes?.users,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <Users />
            {/* <ComingSoon /> */}
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewUser,
      component: (
        <PrivateRoute>
          <ViewUser />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.contactUs,
      component: (
        <PrivateRoute>
          <ContactUs />
        </PrivateRoute>
      ),
    },
    // Static Page
    {
      path: browserRoutes?.staticPage,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <StaticPage />
            {/* <ComingSoon /> */}
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.editStaticPage,
      component: (
        <PrivateRoute>
          <EditStaticPage />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.category,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <Category />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.editCategory,
      component: (
        <PrivateRoute>
          <EditCategory />
        </PrivateRoute>
      ),
    },
    // Recipe Management Routes
    {
      path: browserRoutes?.recipe,
      component: (
        <PrivateRoute>
          <Recipe />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.addRecipe,
      component: (
        <PrivateRoute>
          <AddEditRecipe />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.editRecipe,
      component: (
        <PrivateRoute>
          <AddEditRecipe />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewRecipe,
      component: (
        <PrivateRoute>
          <ViewRecipe />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.subscriptionManagement,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <SubscriptionManagement />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.addSubscriptionPlan,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <AddEditPlan />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.editSubscriptionPlan + "/:id",
      component: (
        <PrivateRoute>
          <PageWrapper>
            <AddEditPlan />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.notificationManagement,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <NotificationManagement />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
  ],
};
